import { useEffect } from "react";
import Navbar from "@/components/marketing/Navbar";
import Footer from "@/components/marketing/Footer";

const SECTIONS = [
  { h: "Estimates", b: "All figures in NetLift are estimates based on the hours, costs, and assumptions you provide." },
  { h: "Your responsibility", b: "You are responsible for the assumptions, costs, and data entered into your workspace." },
  { h: "Not professional advice", b: "NetLift is not accounting, tax, legal, or HR advice. Use the outputs to support decisions, not replace professional judgment." },
  { h: "Staff cost data", b: "Staff cost data must be entered only by authorized users. Do not upload data you are not permitted to use." },
  { h: "Subscription and cancellation", b: "Subscriptions renew monthly. You can cancel anytime and access continues until the end of the paid billing period." },
  { h: "Acceptable use", b: "Do not use NetLift to break laws or the rights of others, or to overload the service." },
  { h: "No employee surveillance", b: "NetLift is for AI rollout decisions. It must not be used as an employee monitoring or surveillance tool." },
];

export default function Terms() {
  useEffect(() => { document.title = "Terms of Use | NetLift"; }, []);
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="mx-auto max-w-3xl px-5 py-20 sm:px-8">
        <h1 className="font-heading text-4xl font-semibold tracking-tight text-slate-900">Terms of Use</h1>
        <p className="mt-3 text-sm text-slate-500">Please read these terms before using NetLift.</p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <div key={s.h}>
              <h2 className="font-heading text-lg font-medium text-slate-900">{s.h}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.b}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
